import { VariablesToTest } from "./variablesToTest";
import {
  DEFAULT_SCRATCH_DEDUCTION,
  getScratchKey,
  hasScratch,
  setScratchFields,
} from "./scratch";

export const TestsElements = ({
  itemResult,
  saveDataRef,
  setBtnLoading,
  callGetCombine,
}) => {
  const scratchKey = getScratchKey(itemResult);

  return (
    <div className=" border border-blue-700 rounded px-4 py-3 items-center mb-3">
      <div className="font-normal">
        <b className="text-[#5057FF]">{itemResult?.attempt}: </b>{" "}
        {itemResult?.name}
      </div>
      {itemResult?.test?.map((itemTest, indexTest) => (
        <VariablesToTest
          key={indexTest}
          itemTest={{
            ...itemTest,
            physicalTestName: itemResult?.name,
            unit: itemResult?.unit,
          }}
          saveDataRef={saveDataRef}
          setBtnLoading={setBtnLoading}
          callGetCombine={callGetCombine}
        />
      ))}
      {hasScratch(itemResult) && (
        <div className="flex items-center my-2">
          <input
            type="checkbox"
            id={`scratch-${scratchKey}`}
            className="ml-3"
            onChange={(e) =>
              setScratchFields(
                scratchKey,
                e.target.checked ? DEFAULT_SCRATCH_DEDUCTION : null,
              )
            }
          />
          <label htmlFor={`scratch-${scratchKey}`} className="ml-2">
            Scratch
          </label>
          <label htmlFor={`scratchDeduction-${scratchKey}`} className="ml-6">
            Deduction (s):
          </label>
          <input
            type="number"
            id={`scratchDeduction-${scratchKey}`}
            className="ml-3 bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg block w-16 md:w-20 p-2.5 disabled:opacity-50"
            placeholder="0.000"
            min={0}
            step="0.001"
            disabled
            onWheel={(e) => e.currentTarget.blur()}
          />
        </div>
      )}
    </div>
  );
};
